import { ingressListIngressesCompatibleWithCertificate } from "../../api/Mittwald";
import { lastEventIdStore } from "../lib/lastEventIdStore";
import type { RequestInterceptor } from "./types";

export const setLastEventRequestHeader: RequestInterceptor = (request) => {
  const { url, method } = request;
  if (!url || !method) {
    return request;
  }

  if (
    method !== "GET" &&
    url !== ingressListIngressesCompatibleWithCertificate.path
  ) {
    return request;
  }

  const lastEventId = lastEventIdStore.get(url);

  if (lastEventId) {
    request.headers.set("if-event-reached", lastEventId);
  }

  return request;
};
